<div edsFlexbox justifyContent="space-between" edsPadding edsPaddingTop="xs">
  <div>
    <eds-title size="small-light">
      {{ "products.ratings-title" | translate }}
      <eds-footnote *ngIf="placement" [placement]="placement"></eds-footnote>
      <eds-icon
        type="info"
        size="small"
        *ngIf="tooltip"
        edsTooltip
        [tooltipContent]="tooltip"
        [analyticsName]="'products.ratings-title' | translate"
        tooltipBehavior="absolute"
        tooltipPositionDefault="bottom"
      ></eds-icon>
    </eds-title>
    <p class="small text-grey1">
      {{ asOfDateText }}
    </p>
  </div>
  <eds-toggle
    [toggleButtons]="ratingsTypeToggle"
    (toggleActive)="onUpdate($event)"
  ></eds-toggle>
</div>
